export default "__VITE_ASSET__c87250be__"